import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-074c5136")

_pushScopeId("data-v-074c5136")
const _hoisted_1 = { class: "Workbench" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 敬请期待 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { style: {"height":"100%"} }, {
      default: _withId(() => [
        _createVNode(_component_el_container, null, {
          default: _withId(() => [
            _createVNode(_component_el_main, null, {
              default: _withId(() => [
                _createVNode(_component_el_card, { shadow: "always" }, {
                  default: _withId(() => [
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
})